module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footer', {
    staticClass: "kbx-form-footer"
  }, [_c('a', {
    staticClass: "kbx-btn",
    style: (_vm.stepStyle('welcome-button-positive')),
    attrs: {
      "klickbox-edit-item": "welcome-button-positive",
      "klickbox-edit-label": _vm.$t('edit.canvas.positive_button')
    }
  }, [_vm._v("\n      " + _vm._s(_vm.stepPreview.options[0].label) + "\n    ")]), _vm._v(" "), (_vm.stepPreview.welcome_option === 'yes-no') ? _c('a', {
    staticClass: "kbx-btn",
    style: (_vm.stepStyle('welcome-button-negative')),
    attrs: {
      "klickbox-edit-item": "welcome-button-negative",
      "klickbox-edit-label": _vm.$t('edit.canvas.negative_button')
    }
  }, [_vm._v("\n      " + _vm._s(_vm.stepPreview.options[1].label) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-76adf9de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/step/welcome/Buttons.vue
 ** module id = 863
 ** module chunks = 1
 **/